module.exports = __webpack_public_path__ + "static/img/anLiBoxImg3.a826472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anLiBoxImg3.png
// module id = 0x5M
// module chunks = 2